
import { SearchOutlined } from '@ant-design/icons'
import { Input, Table, Typography } from 'antd'
import React from 'react'
import { buscar_cantidad_aspirantes } from '../../functions/arreglos'
import useReporteGeneral from '../../hooks/adminexamen/useReporteGeneral'

const InscribirAspirantes = () => {

  const { aspirantesPendientesInscribir, columns, loading, setBuscarPendienteInscribir, buscarPendienteInscribir } = useReporteGeneral( 0 )

  let columnas_que_no_quiero = [ 'Expresión oral y escrita', 'Matemáticas ciencias', 'Matemáticas EA', 'Inglés', 'Acciones' ]

  // aquí sólo traigo las columnas que no están en el arreglo "columnas_que_no_quiero"
  const columnas_filtradas = columns.filter( a => !columnas_que_no_quiero.includes( a.title ) )


  // cantidad
  var cantidad_aspirantes = buscar_cantidad_aspirantes( aspirantesPendientesInscribir )

  const { Title } = Typography;

  return (
    <>
      <Title level={3}>Aspirantes pendientes de inscribir</Title>
      <Table
        loading={ loading }
        columns={ columnas_filtradas }
        rowKey="pk_aspirante"
        title = { () => (
            <>
              <h1>{ cantidad_aspirantes }</h1>
              <Input size='large' id='inputBuscarEstadoExamen' autoComplete='off' placeholder="Buscar aspirante" allowClear onChange={ e => setBuscarPendienteInscribir( e.target.value )  } value={ buscarPendienteInscribir } prefix={ <SearchOutlined /> }/>
            </>
        )}
        showSorterTooltip={ false }
        dataSource={ aspirantesPendientesInscribir }
      />

    </>
  )
}

export default InscribirAspirantes
